import React, { memo } from 'react'

const NoticeGuide = () => {
  return (
    <section className="notice-container">
      <h3>Lưu ý:</h3>
      <ol>
        <li>
        Hệ thống AI là hệ thống trí tuệ nhân tạo.
        </li>
        <li>
        Chương trình kiểm tra sức khỏe răng miệng với hệ thống AI của P/S dành cho mọi đối tượng và miễn phí, tuy nhiên, trẻ em dưới 16 tuổi cần có sự giám sát và hướng dẫn của phụ huynh.
        </li>
        <li>
        Hình ảnh răng miệng mà bạn cung cấp cho hệ thống AI sẽ được bảo mật tuyệt đối và được xóa ngay khi bạn hoàn thành quá trình kiểm tra.
        </li>
        <li>
        Khi bạn tham gia chương trình, bạn cần hiểu rằng bạn đang tương tác với AI chứ không phải con người. Chúng tôi sẽ xử lý các dữ liệu cá nhân mà bạn cung cấp theo Thông báo quyền riêng tư của Unilever mà bạn cần đọc và đồng ý trước khi đăng ký tham gia.
        </li>
        <li>
        Nếu tham gia trực tiếp tại các cửa hàng siêu thị, bạn sẽ có cơ hội nhận được voucher 10.000đ để trải nghiệm Bàn chải P/S 4D & Kem Đánh Răng P/S Chuyên Gia Chăm Sóc Nướu. Mỗi số điện thoại chỉ được nhận 01 voucher và voucher sẽ có thời hạn nhất định tại mỗi hệ thống siêu thị.
        </li>
        <li>
        Liên hệ Hotline <b>028 38236651</b> hoặc Fanpage P/S Bảo Vệ Nụ Cười Việt Nam nếu cần thêm thông tin chi tiết.
        </li>
      </ol>
    </section>
  )
}
export default memo(NoticeGuide)